import { useEffect, useState } from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Manifesto from "../components/Manifesto";
import FeaturedProjects from "../components/FeaturedProjects";
import LiveProgress from "../components/LiveProgress";
import Marquee from "../components/Marquee";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import LoaderIntro from "../components/LoaderIntro";
import { api } from "../lib/api";

export default function Home() {
  const [ready, setReady] = useState(false);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => {});
  }, []);

  return (
    <>
      {!ready && <LoaderIntro onDone={() => setReady(true)} />}
      <Nav />
      <main id="top">
        <Hero />
        <Manifesto />
        <FeaturedProjects projects={projects} />
        <LiveProgress projects={projects} />
        <Marquee />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
